<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_partner_contract"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :show-del="false"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="isPartnerUser"
        @on-add="showFormModalDialog"
      />
      <ContractFormDialog
        :id="entityId"
        :visible="modalForm"
        :width="560"
        :action="url"
        @on-close="onModalClose"
      />
      <ContractStatus
        :id="entityId"
        :action="url"
        :current-status="currentStatus"
        :visible="modalStatus"
        @on-close="onModalClose"
      />
      <ContractView
        :data="rowData"
        :visible="modalView"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
import ContractFormDialog from './contract-details'
import ContractStatus from './contract-status'
import ContractView from './contract-view'
import { dateFormat } from '@/utils/util'
import { isPartner } from '@/utils/app'
import { getLinkTextStyle } from '@/utils/util'
export default {
  name: 'PartnerContractList',
  components: { TableWrapper, ContractFormDialog, ContractStatus, ContractView },
  data() {
    return {
      url: this.$config.apiContextPath + '/partner/contract',
      modalForm: false,
      entityId: 0,
      modCount: 0,
      modalStatus: false,
      modalView: false,
      currentStatus: 0,
      rowData: null,
      types: this.loadPartnerTypes()
    }
  },
  computed: {
    isPartnerUser() {
      return isPartner()
    },
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '合伙人姓名', placeholder: '请输入合伙人姓名...', name: 'name', width: 'auto', type: 'input' },
          { label: '合伙人手机', placeholder: '请输入合伙人手机号...', name: 'mobile', width: 'auto', type: 'input' },
          { label: '合伙人角色', placeholder: '请选择合伙人角色...', name: 'type', width: '200px', type: 'select', options: this.types },
          { label: '处理状态', placeholder: '请选择合同状态...', name: 'status', width: 'auto', type: 'select', options: [
            { label: '待处理', value: 0 },
            { label: '进行中', value: 1 },
            { label: '已完成', value: 2 },
            { label: '已拒绝', value: 3 }
          ] }
        ]
      }
    },
    // mockData() {
    //   return [
    //     {
    //       // 大部分字段是join其他表查出来的, 当然也可以是冗余字段
    //       userId: 1, // 用户id
    //       memberName: '张三', // 用户名
    //       partnerType: '授权合伙人', // 合伙人类型
    //       mobile: '13612345678', // 用户手机号
    //       // parkingId: 2, // 车库id
    //       parking: '远大中央公园1期', // 车库名
    //       contract: 'test.doc', // 合同路径
    //       status: 0,
    //       createTime: '2020-04-05 22:24', // 上传时间
    //       updateTime: '2020-04-25 23:01' // 更新时间
    //     }
    //   ]
    // },
    columns() {
      const _this = this
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '合伙人', align: 'center', key: 'memberName', width: 110, sortable: true, ellipsis: true, tooltip: true },
        { title: '手机号', align: 'center', key: 'mobile', width: 130, sortable: true, ellipsis: true, tooltip: true },
        { title: '合伙人类型', align: 'center', key: 'partnerType', width: 140, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.partnerType || '---')
          }
        },
        { title: '合同有效期', align: 'center', sortable: true, width: 140, key: 'expireTime', ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.expireTime ? dateFormat(new Date(params.row.expireTime), 'yyyy-MM-dd') : '---')
          }
        },
        { title: '车库名', align: 'center', key: 'parkingName', width: 140, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.parkingName || '---')
          }
        },
        { title: '车库容量', align: 'center', key: 'parkingCapacity', width: 120, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.parkingCapacity || '---')
          }
        },
        { title: '运营日期', align: 'center', key: 'parkingOnline', width: 120, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.parkingOnline || '---')
          }
        },
        { title: '备注', align: 'center', key: 'remarks', width: 120, sortable: true, ellipsis: true, tooltip: true },
        { title: '处理状态', align: 'center', key: 'status', width: 130, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: _this.getStatusByCode(params.row.status).color }
            }, _this.getStatusByCode(params.row.status).text)
          }
        },
        // { title: '合同下载', align: 'center', key: 'contract', sortable: true, ellipsis: true, tooltip: true },
        { title: '创建时间', align: 'center', sortable: true, width: 160, key: 'createTime', ellipsis: true, tooltip: true },
        { title: '更新时间', align: 'center', sortable: true, width: 160, key: 'updateTime', ellipsis: true, tooltip: true },
        { title: '操作人员', align: 'center', sortable: true, width: 120, key: 'operator', ellipsis: true, tooltip: true, show: !this.isPartnerUser },
        { title: '操作', align: 'center', width: 220, key: '_actions', disabled: true, fixed: 'right',
          render: (h, params) => {
            const _this = this
            return h('div', [
              // h('a', {
              //   domProps: {
              //     href: _this.$config.storageHost + '/contract/' + params.row.contract,
              //     target: '_blank'
              //   },
              //   style: { color: '#126D91', marginRight: '10px' }
              // }, [
              //   h('i', { class: { 'fas': true, 'fa-cloud-download-alt': true, 'cell-icon-link': true }}),
              //   h('span', {}, '下载')
              // ]),
              h('a', {
                style: getLinkTextStyle(params.row.status === 0),
                on: {
                  click: () => {
                    if (params.row.id && params.row.status === 0) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              // h('a', {
              //   style: { color: '#126D91', marginRight: '10px' },
              //   on: {
              //     click: () => {
              //       if (params.row.id) {
              //         this.showFormModalDialog(params.row.id)
              //       }
              //     }
              //   }
              // }, [
              //   h('i', { class: { 'fas': true, 'fa-check': true, 'cell-icon-link': true }}),
              //   h('span', {}, '完成')
              // ]),
              h('a', {
                style: getLinkTextStyle(params.row.status === 0),
                on: {
                  click: () => {
                    if (params.row.id && params.row.status === 0) {
                      this.showDelModalDialog(params.row.id, params.row)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ]),
              h('Dropdown', {
                props: { trigger: 'hover', placement: 'bottom' },
                on: {
                  'on-click': (name) => {
                    this.onDropdownItemClick(name, params.row)
                  }
                }
              }, [
                h('DropdownItem', { style: { color: '#126D91' }}, [
                  h('i', { class: { 'fas': true, 'fa-layer-group': true, 'cell-icon-link': true }}),
                  '其他操作',
                  h('Icon', { props: { type: 'ios-arrow-down' }})
                ]),
                h('DropdownMenu', { slot: 'list' }, [
                  h('DropdownItem', {
                    props: { name: 'action_view' }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-eye': true, 'cell-icon-link': true }}),
                    h('span', {}, '查看合同')
                  ]),
                  h('DropdownItem', {
                    props: { name: 'action_changeStatus', disabled: _this.isPartnerUser || (params.row.status === 2 || params.row.status === 3) }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-exchange-alt': true, 'cell-icon-link': true }}),
                    h('span', {}, '变更状态')
                  ])
                ])
              ])
            ])
          }
        }
      ] // .filter(column => column.show === undefined || column.show)
    }
  },
  methods: {
    getStatusByCode(code) {
      const status = [
        { text: '待处理', color: 'red' },
        { text: '进行中', color: 'blue' },
        { text: '已完成', color: 'green' },
        { text: '已拒绝', color: '#ccc' }
      ]
      return code < status.length ? status[code] : { text: '', color: '' }
    },
    async loadPartnerTypes() {
      await request({
        url: this.$config.apiContextPath + '/partner/type/all',
        method: 'get'
      }).then(res => {
        this.types = []
        const items = res.data
        items.forEach(i => {
          this.types.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.types = []
      })
    },
    onModalClose(changed) {
      this.entityId = 0
      this.modalForm = false
      this.modalStatus = false
      this.modalView = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    onDropdownItemClick(name, data) {
      if (name === 'action_view') {
        this.showContract(data.id, data)
      } else if (name === 'action_download') {
        window.open(this.$config.storageHost + '/contract/' + data.contract)
      } else if (name === 'action_changeStatus') {
        this.showContractStatus(data.id, data.status)
      }
    },
    showContract(id, data) {
      this.entityId = id ? parseInt(id) : 0
      this.rowData = data
      this.modalView = true
    },
    showContractStatus(id, status) {
      this.entityId = id ? parseInt(id) : 0
      this.currentStatus = status
      this.modalStatus = true
    },
    showDelModalDialog: function(id, data) {
      const _this = this
      if (!id) { return }
      this.$Modal.confirm({
        title: '确认删除合同信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [
            h('li', {}, '合伙人姓名：' + data.memberName),
            h('li', {}, '合伙人车库：' + data.parkingName)
          ])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({ title: '数据删除成功', desc: '合同删除成功!' })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({ title: '数据删除失败', desc: '合同删除失败, 错误信息: ' + error })
            _that.buttonLoading = false
          })
        }
      })
    },
    showFormModalDialog(id = '') {
      this.modalForm = true
      this.entityId = id ? parseInt(id) : 0
    }
  }
}
</script>
